import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { STORAGE_KEY_INVITATION_ID } from '../_constants/storage.constants';
import { publicApi } from '../_providers/http-context-tokens';

@Service()
export class InstitutionInvitationService {
  readonly #http = inject(HttpClient);

  readonly getId = (): string | null =>
    localStorage.getItem(STORAGE_KEY_INVITATION_ID);

  readonly setId = (id: string): void => {
    localStorage.setItem(STORAGE_KEY_INVITATION_ID, id);
  };

  readonly clear = (): void => {
    localStorage.removeItem(STORAGE_KEY_INVITATION_ID);
  };

  readonly fetchEmail = (id: string): Observable<{ email: string }> =>
    this.#http.get<{ email: string }>(
      `/api/institutions/invitations/${id}`,
      publicApi(),
    );

  // Completes a pending invitation for the currently authenticated session.
  // Used when an already-logged-in user follows an invitation link, so the
  // institution link is made without requiring a fresh login (DUNX-88). The
  // backend returns 200 with the frontend redirect target, or 204 (empty body)
  // when there is nothing to complete (unknown/expired/other-email invitation).
  // No publicApi() here: /complete is ROLE_USER-guarded, so it must keep the
  // Authorization header.
  readonly complete = (id: string): Observable<{ redirectTo: string } | null> =>
    this.#http.post<{ redirectTo: string } | null>(
      '/api/institutions/invitations/complete',
      { invitationId: id },
    );
}
